import React, { useEffect, useState } from "react";
import { Col, Form, Input, Radio, Row, Typography } from "antd";
import { userRols } from "../../../helpers/userRols";
import toBoolean from "../../../helpers/toBoolean";

const { Text } = Typography;
const ProfessionalCompanyData = ({ adminRole, iban, vat }) => {
  const [isRegistered, setIsRegistered] = useState(
    vat?.isRegistered ? vat?.isRegistered?.toString() : "",
  );
  const [isFirmRegistered, setIsFirmRegistered] = useState(
    vat?.isFirmRegistered ? vat?.isFirmRegistered?.toString() : "",
  );

  useEffect(() => {
    if (vat) {
      setIsRegistered(vat?.isRegistered?.toString());
      setIsFirmRegistered(vat?.isFirmRegistered?.toString());
    }
  }, [vat]);
  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Регистрация по ДДС"
          name={["metadata", "vat", "isRegistered"]}
          initialValue={vat?.isRegistered}
        >
          <Radio.Group
            defaultValue={toBoolean(isRegistered?.toString())}
            onChange={({ target }) => setIsRegistered(target.value)}
          >
            <Radio value={"true"}>Да</Radio>
            <Radio value={"false"}>Не</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={12}>
        {toBoolean(isRegistered?.toString()) ? (
          <Form.Item
            label="ДДС номер"
            name={["metadata", "vat", "vatNumber"]}
            rules={[{ required: true, message: "Моля, въведи ДДС номер" }]}
          >
            <Input placeholder="BGXXXXXXXXX" />
          </Form.Item>
        ) : (
          <Text>Няма регистрация по ДДС</Text>
        )}
      </Col>

      <Col span={12}>
        <Form.Item
          label="Работи за юридическо лице?"
          name={["metadata", "vat", "isFirmRegistered"]}
          initialValue={isFirmRegistered?.toString()}
        >
          <Radio.Group
            onChange={({ target }) => setIsFirmRegistered(target.value)}
          >
            <Radio value={"true"}>Да</Radio>
            <Radio value={"false"}>Не</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {toBoolean(isFirmRegistered?.toString()) && (
        <>
          <Col span={12}>
            <Form.Item
              label="Име на фирма"
              name={["metadata", "companyName"]}
              rules={[{ required: true, message: "Моля, въведи име на фирма" }]}
            >
              <Input placeholder="BGXXXXXXXXX" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Материално отговорно лице"
              name={["metadata", "vat", "accountablePerson"]}
              rules={[
                { required: true, message: "Моля, въведи материално отговорно лице" },
              ]}
            >
              <Input placeholder="Име на материално отговорно лице" />
            </Form.Item>
          </Col>
        </>
      )}

      <Col span={12}>
        <Form.Item
          label="Единен идентификационен код (ЕИК)"
          name={["metadata", "vat", "udNumber"]}
          rules={[{ required: true, message: "Моля, въведи ЕИК" }]}
        >
          <Input placeholder="XXXXXXXXX" />
        </Form.Item>
      </Col>
      <Col span={12}>
        {adminRole === userRols.superAdmin ? (
          <Form.Item
            label="IBAN"
            name={["metadata", "IBAN"]}
            rules={[{ required: true, message: "Моля, въведи IBAN" }]}
          >
            <Input placeholder="BGXXXXXXXXX" />
          </Form.Item>
        ) : (
          <Form.Item
            label="IBAN"
            rules={[{ required: true, message: "Моля, въведи IBAN" }]}
          >
            <Input disabled={true} value={iban} />
          </Form.Item>
        )}
      </Col>
    </Row>
  );
};

export default ProfessionalCompanyData;
